import {
	DELETE_MATCH_COMPLETE,
	EDIT_MATCH_COMPLETE,
	GET_MATCHES,
	GET_MATCHES_COMPLETE,
	SAVE_MATCH_COMPLETE
} from "./constants";

const initialState = {
	matches: [],
	totals: {},
	currentSet: 0
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case GET_MATCHES:
		case GET_MATCHES_COMPLETE:
		case SAVE_MATCH_COMPLETE:
		case EDIT_MATCH_COMPLETE:
		case DELETE_MATCH_COMPLETE: {
			return { ...state, ...payload };
		}
		default:
			return state;
	}
};

export default reducer;
